import {get_current_locate_from_cookie} from "@core/helpers/locate";

import * as moment from "moment";
import "moment/locale/fa";
import {convert_to_en_number} from "@core/helpers/string";
import locates from "@core/constants/date-locates";



const fa_seasons = {
	"بهار": [1, 2, 3],
	"تابستان": [4, 5, 6],
	"پاییز": [7, 8, 9],
	"زمستان": [10, 11, 12]
}
const en_seasons = {
	"Spring": [3, 4, 5],
	"Summer": [6, 7, 8],
	"Fall": [9, 10, 11],
	"Winter": [12, 1, 2],
}


// `settings.time_zone` (optional, e.g. "UTC", like `useDate({ time_zone })`): without a time zone the server prints the
// day of its own zone and the browser the day of the visitor's, so the two can differ by one day (hydration mismatch).
// Without it nothing changes. Every helper below takes the same `settings` as its last argument.
export const get_time_and_date_server = (timestamp, _locate, options, { time_zone } = {}) => {
	const locate = get_current_locate_from_cookie();
	const date = new Date(parseInt(timestamp));
	const formatted = date.toLocaleDateString(
		locates[_locate || locate],
		time_zone ? { timeZone: time_zone, ...(options || {}) } : options
	);
	return formatted;
};

export const get_month_and_year_server = (timestamp, locate, settings) => {
	return get_time_and_date_server(timestamp, locate, {
		year: "numeric",
		month: "long",
	}, settings);
};
export const get_year_server = (timestamp, locate, settings) => {
	return get_time_and_date_server(timestamp, locate, {
		year: "numeric",
	}, settings);
};

export const get_month_and_day_server = (timestamp, locate = "fa", settings) => {
	return get_time_and_date_server(timestamp, locate, {
		day: "numeric",
		month: "long",
	}, settings);
};

export const get_date_server = (timestamp, locate = "fa", settings) => {
	return get_time_and_date_server(timestamp, locate, undefined, settings);
};

export const get_time_server = (timestamp, locate = "fa", settings) => {
	return get_time_and_date_server(timestamp, locate, {
		hour: "2-digit",
		minute: "2-digit",
	}, settings)?.split(", ")?.[1];
};

export const get_duration_time_server = (timestamp, locate = 'fa') => {
	return moment
		.duration(parseInt(timestamp) - Date.now())
		.locale(locate)
		.humanize(true)
};


export const get_date_season_server = (timestamp, locate = 'fa', settings) => {
	const month = convert_to_en_number(get_time_and_date_server(timestamp, locate, {
		month: "numeric",
	}, settings))
	if (locate === 'fa') {
		return Object.keys(fa_seasons)?.find(season => fa_seasons[season].includes(month))
	} else {
		return Object.keys(en_seasons)?.find(season => en_seasons[season].includes(month))
	}
};

